import { formatPriceValue } from "helpers/string.helpers";
import { DOLLAR, PERMONTH } from "../constants/OfferPage.constants";

export const getPricePerMonth = (offerPrice: number) => `${DOLLAR}${formatPriceValue(offerPrice)}${PERMONTH}`;